module.exports = __webpack_public_path__ + "img/q-flow.2d9752d1.jpg";